import getConfig from 'lib/next-config-compat';
import { useRouter } from 'next/router';
import { createContext, type ReactNode } from 'react';

export interface AppContextValue {
  imageBaseUrl: string;
  currentRoute: string;
}

export const AppContext = createContext<AppContextValue>({
  imageBaseUrl: '',
  currentRoute: '',
});

const AppProvider = ({ children }: { children: ReactNode }) => {
  const {
    publicRuntimeConfig: { baseUrl: imageBaseUrl = '' },
  } = getConfig();
  const { asPath = '' } = useRouter();

  return (
    <AppContext.Provider value={{ imageBaseUrl, currentRoute: asPath }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
